import { render, staticRenderFns } from "./QuizTemplate2.vue?vue&type=template&id=c8e2201e"
import script from "./QuizTemplate2.vue?vue&type=script&lang=js"
export * from "./QuizTemplate2.vue?vue&type=script&lang=js"
import style0 from "./QuizTemplate2.vue?vue&type=style&index=0&id=c8e2201e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports